import React, { useState, useEffect, Fragment, useMemo } from "react";
import { ToastContainer } from "react-toastify";
import { Form } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { useSelector, useDispatch } from 'react-redux';
import swal from "sweetalert";
import { authActions, changepasswordActions } from '../../../_store';
import Toastr from '../../components/common/Toastr';
import { Button, Modal } from "react-bootstrap";
import validator from "validator"; //https://www.npmjs.com/package/validator




const ChangePassword = () => {
    const dispatch = useDispatch();
    const currentUser = useSelector(x => x.auth.user);
    const userList = useSelector(x => x.users.users);
    const changepasswordResponse = useSelector(x => x.changepassword.changepasswordResponse);
    const [submitted, setSubmitted] = useState(false);
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isRevealPwd1, setIsRevealPwd1] = useState(false);
    const [isRevealPwd2, setIsRevealPwd2] = useState(false);



    const [addFormData, setAddFormData] = useState({
        UserID: currentUser.Id,
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: '',
        IsValidpassword: true

    });
    const newFormData = { ...addFormData };

    useEffect(() => {
        if(localStorage.getItem('filterValues')){
            localStorage.removeItem('filterValues');
          }
        dispatch(changepasswordActions.clearChangeResponse());
    }, []);

    // Add contact function
    const handleChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value;
        const newFormData = { ...addFormData };
        newFormData[fieldName] = fieldValue;
        if (fieldValue && fieldValue.trim()) {
            if (fieldName === "NewPassword") {
                newFormData.IsValidpassword = validator.isStrongPassword(fieldValue);
                newFormData[fieldName] = fieldValue;
            }
        } else {
            newFormData[fieldName] = fieldValue.trim();
        }

        setAddFormData(newFormData);
    };


    //Add Submit data
    const handleSubmit = (event) => {
        var error = false;
        var errorMsg = '';
        if (!addFormData.OldPassword || !addFormData.NewPassword || !addFormData.ConfirmPassword) {
            error = true;
        }
        if (!error) {
            // dispatch(changepasswordActions.savechangepassword(newFormData));
            if (addFormData.IsValidpassword === false) {
                Toastr('Please enter valid password.', 'warning');
            } else if (newFormData.OldPassword.trim() === newFormData.NewPassword.trim()) {
                Toastr('The old password and the new password are the same.', 'warning');

            }
            else if (newFormData.NewPassword.trim() !== newFormData.ConfirmPassword.trim()) {
                Toastr('The new password and the confirm new password do not match.', 'warning');
            }
            else {
                swal({
                    title: "",
                    text: "If you change the password, application will logged out. Are you sure you want to continue?",
                    icon: "warning",
                    buttons: true,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    dangerMode: true,
                }).then((willDelete) => {
                    if (willDelete) {
                        dispatch(changepasswordActions.savechangepassword(newFormData));
                    }
                })

            }

        }
        else {
            setSubmitted(true);
            Toastr('Please fill in the required missing fields', 'warning');
        }

    };

    // Reset Input Field
    const resetInputField = () => {
        setSubmitted(false);
        newFormData.IsValidpassword = true;
        newFormData.OldPassword = newFormData.NewPassword = newFormData.ConfirmPassword = '';
        setAddFormData(newFormData);
    };

    useEffect(() => {

        if (changepasswordResponse === 1) {
            swal({
                text: "Password has been changed successfully. Please login again",
                icon: "success",
                closeOnClickOutside: false,
                closeOnEsc: false,

            }).then(() => {
                dispatch(authActions.logout({}));
                dispatch(changepasswordActions.clearChangeResponse());

            })

        } else if (changepasswordResponse === 2) {
            Toastr('Old Password is incorrect', "warning");
            dispatch(changepasswordActions.clearChangeResponse());
        } else if (changepasswordResponse === 4) {
            Toastr('The old password and the new password are the same.', "warning");
            dispatch(changepasswordActions.clearChangeResponse());

        } else if (changepasswordResponse === 3) {
            Toastr('Inactive User', "warning");
            dispatch(changepasswordActions.clearChangeResponse());

        } else if (changepasswordResponse === 5) {
            Toastr('Invalid Credentials ', "warning");
            dispatch(changepasswordActions.clearChangeResponse());

        }

    }, [changepasswordResponse]);



    return (
        <Fragment>
            <PageTitle activeMenu="Change Password" motherMenu="Settings" />
            <ToastContainer />
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">

                                <div className="col-xs-12 col-md-6 col-lg-4">
                                    {/* <h4 className="mb-3">Change Password</h4> */}



                                    <div className="mb-3">
                                        <label className="text-black font-w700">Old Password <span className="text-danger">*</span></label>
                                        <div className="input-group mb-3">
                                            <input
                                                className={`form-control ${(submitted && !addFormData.OldPassword) && 'border-danger'}`}
                                                type={isRevealPwd ? "text" : "password"}
                                                name="OldPassword"
                                                placeholder="Old Password"
                                                required=""
                                                maxLength={15}
                                                value={addFormData.OldPassword}
                                                onChange={handleChange}
                                            />
                                            <span className="input-group-text togglePassword">
                                                <i title={isRevealPwd ? "Hide password" : "Show password"}
                                                    className={isRevealPwd ? "fa fa-eye-slash PasswordHideShow" : "fa fa-eye PasswordHideShow"}
                                                    onClick={() => setIsRevealPwd(prevState => !prevState)}
                                                />
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="text-black font-w700">New Password <span className="text-danger">*</span></label>
                                        <div className="input-group mb-3">
                                            <input
                                                className={`form-control ${(submitted && (!addFormData.NewPassword || !newFormData.IsValidpassword)) && 'border-danger'}`}
                                                type={isRevealPwd1 ? "text" : "password"}
                                                name="NewPassword"
                                                placeholder="New Password"
                                                required=""
                                                value={addFormData.NewPassword}
                                                onChange={handleChange}
                                                maxLength={15}
                                            />
                                            <span className="input-group-text togglePassword">
                                                <i title={isRevealPwd1 ? "Hide password" : "Show password"}
                                                    className={isRevealPwd1 ? "fa fa-eye-slash PasswordHideShow" : "fa fa-eye PasswordHideShow"}
                                                    onClick={() => setIsRevealPwd1(prevState => !prevState)}
                                                />
                                            </span>
                                        </div>
                                        <span className="validation-text text-danger">{!newFormData.IsValidpassword && "Password must contain 8 characters and atleast one Uppercase, Lowercase, Number and Special character. (Eg. Qwerty@123)"}</span>
                                    </div>

                                    <div className="mb-3">
                                        <label className="text-black font-w700">Confirm New Password <span className="text-danger">*</span></label>
                                        <div className="input-group mb-3">
                                            <input
                                                type={isRevealPwd2 ? "text" : "password"}
                                                className={`form-control ${(submitted && !addFormData.ConfirmPassword) && 'border-danger'}`}
                                                name="ConfirmPassword"
                                                placeholder="Confirm New Password"
                                                required=""
                                                value={addFormData.ConfirmPassword}
                                                onChange={(e) => handleChange(e)}
                                                maxLength={15}
                                            />
                                            <span className="input-group-text togglePassword">
                                                <i title={isRevealPwd2 ? "Hide password" : "Show password"}
                                                    className={isRevealPwd2 ? "fa fa-eye-slash PasswordHideShow" : "fa fa-eye PasswordHideShow"}
                                                    onClick={() => setIsRevealPwd2(prevState => !prevState)}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    {/* 
                                        <div className="mb-3">
                                            <button
                                                className="btn btn-primary btn-lg btn-block  mb-2"
                                                type="submit"
                                            >
                                                Change Password
                                            </button>
                                        </div> */}
                                    {/* <div className="col-12">
                                            <button type="reset" className="btn btn-danger mb-2">
                                                Reset
                                            </button>
                                            <button type="submit" className="btn btn-primary mb-2">
                                                Change Password
                                            </button>
                                        </div> */}

                                    <Button
                                        variant="danger light"
                                        onClick={() => resetInputField()}
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        onClick={(e) => handleSubmit(e)}
                                        variant=""
                                        className="btn btn-primary m-3"  >
                                        Change Password
                                    </Button>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ChangePassword;
